import { render, staticRenderFns } from "./FanTable.vue?vue&type=template&id=150c313a&scoped=true&"
import script from "./FanTable.vue?vue&type=script&lang=js&"
export * from "./FanTable.vue?vue&type=script&lang=js&"
import style0 from "./FanTable.vue?vue&type=style&index=0&id=150c313a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150c313a",
  null
  
)

export default component.exports